export const environment = {
  apiUrl: 'https://anuax-hakikat.web.app/api/v1'
};
